export enum CARRINHO_STEP {
  DATA = 1,
  TIPO_INGRESSO = 2,
  IDENTIFICACAO = 3,
  PAGAMENTO = 4,
  CONFIRMACAO = 5,
}
